'use client';

import { freddyTheme, ListItem } from '@coolblue-development/freddy';
import { ReactNode } from 'react';

type CellProps = { children: ReactNode };

const Cell = ({ children }: CellProps) => (
  <ListItem
    py={200}
    px={300}
    sx={{
      minWidth: '18.5rem',
      '&:first-of-type:not(:only-of-type)': {
        backgroundColor: freddyTheme.color.background.secondary
      }
    }}
  >
    {children}
  </ListItem>
);

export default Cell;
